<div class="content-inner">
    <div class="form-body" [formGroup]="totalUOSForm" *ngIf="shiftRecord.prevShiftRecord">
        <div class="workflow-input">
            <div class="workflow-section-heading">Projected {{unitOfServiceName}}</div>
            <div class="projected-uos"><input type="text" disabled [value]="getProjectedScheduledUos()" /> Scheduled</div>
            <div class="projected-addons" *ngIf="isAddOnsPresent(prevShiftRecord.shiftBlock.addOns)"><input type="text" disabled [value]="getAddOns()" /> Net Add Ons</div>
        </div>
        <div class="workflow-section-heading enter-uos">Enter {{unitOfServiceName}}</div>       
        <span *ngIf="hasTotalUosImports()" [ngClass]="hasImportedDataValues ? 'has-imported-data' : 'no-imported-data'" (click)="openImportedValuesModal(block)">
            <span class="icon-download3"></span></span>
        <span *ngIf="hasImportedDataValues">
            &nbsp;&nbsp;&nbsp;<button class="compact" (click)="editImported()"><span class="icon-pencil"></span> Edit</button>
         </span>
        <section class="workflow-input-group">
            <div class="workflow-input-labels">
                <span>Planned</span>
                <span>Actual</span>
            </div>
            <div class="workflow-input">
                <input type="text" attr.aria-label="projectedUos" [value]="getProjectedUosTotal()" disabled>
                <input type="number" attr.aria-label="actualUos" formControlName="actualUos">
                <span class="display-label total">Total</span>
                <div *ngIf="valueOutOfRange()" class="validation-message warning">
                    Value must be a whole number between {{minValue}} and {{maxValue | number}}.
                </div>
            </div>
        </section>
        <div *ngIf="hasImportedDataValues">
            <input id="reviewed" type="checkbox" value="checkbox"  formControlName="reviewed" >
            <label for="reviewed">Reviewed</label>
         </div>
        <div class="warning info" *ngIf="!projectedTotalUosRecord">* The information recorded during the previous block is incomplete.  Please complete your missing shift block.</div>
    </div>
    <div *ngIf="!shiftRecord.prevShiftRecord" class="no-previous-block">
        This cost center has no previous shift block.  Please proceed to the next page.
    </div>
    <div class="loading" *ngIf="loadingRecords"></div>
</div>
